module.exports = __webpack_public_path__ + "static/media/logos.6621b83c.png";